import React, { useEffect, useState, Suspense, lazy } from 'react';
import { StickyBanner } from '../components/StickyBanner';
import { Hero } from '../components/Hero';
import { UpsellPopup } from '../components/UpsellPopup';
import { initMetaPixel, trackViewContent, trackAddToCart } from '../utils/metaPixel';
const SocialProof = lazy(() => import('../components/SocialProof').then(m => ({
  default: m.SocialProof
})));
const Bonuses = lazy(() => import('../components/Bonuses').then(m => ({
  default: m.Bonuses
})));
const ValueStackCTA = lazy(() => import('../components/ValueStackCTA').then(m => ({
  default: m.ValueStackCTA
})));
const Footer = lazy(() => import('../components/Footer').then(m => ({
  default: m.Footer
})));
function SectionFallback() {
  return <div className="w-full py-16 flex items-center justify-center" data-id="element-601">
      <div className="w-8 h-8 border-3 border-brand-emerald border-t-transparent rounded-full animate-spin" data-id="element-602"></div>
    </div>;
}
export function LandingPage() {
  const [showUpsell, setShowUpsell] = useState(false);
  useEffect(() => {
    initMetaPixel();
    const timer = setTimeout(() => {
      trackViewContent();
    }, 500);
    return () => clearTimeout(timer);
  }, []);
  const handleBuyClick = () => {
    trackAddToCart();
    setShowUpsell(true);
  };
  return <div className="min-h-screen bg-brand-bg text-brand-textPrimary font-sans overflow-x-hidden" data-id="element-603">
      <StickyBanner data-id="element-604" />
      <UpsellPopup isOpen={showUpsell} onClose={() => setShowUpsell(false)} data-id="element-605" />

      <main className="mt-[48px]" data-id="element-606">
        <Hero onBuyClick={handleBuyClick} data-id="element-607" />

        <Suspense fallback={<SectionFallback data-id="element-609" />} data-id="element-608">
          <SocialProof data-id="element-610" />
          <Bonuses data-id="element-611" />
          <ValueStackCTA onBuyClick={handleBuyClick} data-id="element-612" />
        </Suspense>
      </main>

      <Suspense fallback={<SectionFallback data-id="element-614" />} data-id="element-613">
        <Footer data-id="element-615" />
      </Suspense>
    </div>;
}